<template src="./index.html"></template>
<script>
export default {
	name: '',
	components: {},
	props: {
		sqdiag: {
			type: Boolean,
			default: false
		}
	},
	watch: {
		sqdiag: function(indexVal, oldVal) {
			if (indexVal) {
			}
		}
	},
	data: function() {
		return {
			value: 1
		};
	},
	created() {},
	methods: {
		closediag() {
			this.$emit('closediag', false);
		},
		//申领
		closediagClick() {
			this.$https.fetchPost('/natural/codeAssignment/applyCodeAssignment?applyCount=' + this.value).then(res => {
				if (res.data.code == '200') {
					this.$message.success(res.data.message);
					this.$emit('closediag', false);
				} else {
					this.$essage.error(res.data.message);
				}
			});
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
